export default class Plant {
    constructor(params) {
        this.botanicName = params.botanicName;
        this.familyName = params.familyName;
        this.flowercolor = params.flowercolor;
        this.description = params.description;
        this.categories = params.categories;
        this.continent = params.continent;
        this.dateCreate = params.dateCreate;
        this.flowering = params.flowering;
        this.id = params.id;
        this.maoriName = params.maoriName;
        this.name = params.name;
        this.imgs = params.imgs;
        this.origins = params.origins;

    }
}